import { Button, Grid, MenuItem, Select } from "@mui/material";
import QRCode from "react-qr-code";
import { translate } from "../../i18n/customI18nProvider";
import twintLogo from '../../images/twint-logo.png';
import twintIconCamera from '../../images/twint-icon-camera.svg';
import twintIconQrCode from '../../images/twint-icon-qr_code.svg';

import bankBCV from '../../images/bank-bcv.svg';
import bankCS from '../../images/bank-cs.svg';
import bankPF from '../../images/bank-pf.svg';
import bankRaiffeisen from '../../images/bank-raiffeisen.svg';
import bankUBS from '../../images/bank-ubs.svg';
import bankZKB from '../../images/bank-zkb.svg';
import React from "react";

const platform = window.navigator.userAgent.toLowerCase().includes("android") ? "android" : (window.navigator.userAgent.toLowerCase().includes("iphone") || window.navigator.userAgent.toLowerCase().includes("ipad")) ? "ios" : "web";


export default function TwintToken({ token }) {
    const [bankSelected, setBankSelected] = React.useState(null);
    

    function twintDirectTokenWebRenderer() {
        return (
            <>
                <Grid container spacing={2} style={{backgroundColor: '#f5f5f5', flex: 1, justifyContent: 'space-around', paddingTop: 50}}>
                    <Grid item xs={12} sm={12} md={6} style={{textAlign: 'center'}}>
                        <div style={{backgroundColor: '#fefefe', display: 'inline-flex', borderRadius: 20}}>
                            <div style={{margin: 20}}>
                                <QRCode value={token} bgColor="#fefefe" />
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} style={{textAlign: 'center'}}>
                        <div style={{backgroundColor: '#fefefe', height: '100%', display: 'inline-flex', borderRadius: 20, minHeight: 100}}>
                            <div style={{margin: 'auto', marginLeft: 20, marginRight: 20}}>
                                {(String(token).split('').map((twint_direct_token_split, index) => {
                                    return (
                                        <span key={index} style={{backgroundColor: '#e6e6e6', padding: 15, margin: 5, borderRadius: 5, fontSize: 30, fontWeight: '600'}}>
                                            {twint_direct_token_split}
                                        </span>
                                    )
                                }))}
                            </div>
                        </div>
                    </Grid>
                </Grid>

                <Grid container spacing={2} style={{backgroundColor: '#f5f5f5', flex: 1, justifyContent: 'space-around', paddingTop: 50}}>
                    <Grid item xs={12} sm={12} md={4} style={{textAlign: 'center', padding: 20}}>
                        <img src={twintLogo} height={50} width={'auto'} style={{borderRadius: 10}} />
                        <p>{translate('custom.open_the_twint_app_of_your_bank_on_your_smartphone')}</p>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} style={{textAlign: 'center', padding: 20}}>
                        <img src={twintIconCamera} height={50} width={'auto'} />
                        <p>{translate('custom.select_the_qr_code_symbol')}</p>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} style={{textAlign: 'center', padding: 20}}>
                        <img src={twintIconQrCode} height={50} width={'auto'} />
                        <p>{translate('custom.point_your_smartphone_camera_at_the_qr_code_or_select_the_code_tab_and_enter_the_number_code')}</p>
                    </Grid>
                </Grid>
            </>
        )
    }

    function twintDirectTokenAndroidIosCommonRenderer() {
        return (
            <>
                {/* Divider with text */}
                <Grid item xs={12} style={{textAlign: 'center'}}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20}}>
                        <div style={{borderBottom: '1px solid gray', width: '40%'}}></div>
                        <div style={{paddingLeft: 10, paddingRight: 10}}>{translate('custom.or')}</div>
                        <div style={{borderBottom: '1px solid gray', width: '40%'}}></div>
                    </div>
                </Grid>

                {/* Helper Text */}
                <Grid item xs={12} style={{textAlign: 'center'}}>
                    <p>{translate('custom.enter_this_code_in_your_twint_app')}</p>
                </Grid>

                <Grid item xs={12} style={{textAlign: 'center'}}>
                    <div style={{backgroundColor: '#fefefe', height: '100%', display: 'inline-flex', borderRadius: 20, minHeight: 100}}>
                        <div style={{margin: 'auto', marginLeft: 20, marginRight: 20}}>
                            {(String(token).split('').map((twint_direct_token_split, index) => {
                                return (
                                    <span key={index} style={{backgroundColor: '#e6e6e6', padding: 15, margin: 5, borderRadius: 5, fontSize: 30, fontWeight: '600'}}>
                                        {twint_direct_token_split}
                                    </span>
                                )
                            }))}
                        </div>
                    </div>
                </Grid>

                {/* outlined button to copy the code to clipboard */}
                <Grid item xs={12} style={{textAlign: 'center'}}>
                    <Button
                        variant="outlined"
                        size="large"
                        style={{color: '#262626', borderColor: '#262626', marginTop: 20, marginBottom: 20, textTransform: 'none'}}
                        onClick={() => {
                            navigator.clipboard.writeText(token).then(() => {
                                alert(translate('custom.copied_to_clipboard'));
                            });
                        }}
                    >
                        {translate('custom.copy_code')}
                    </Button>
                </Grid>
            </>
        )
    }

    function twintDirectTokenAndroidRenderer() {
        return (
            <>

                <Grid container spacing={2} style={{backgroundColor: '#f5f5f5', flex: 1, justifyContent: 'space-around', paddingTop: 50}}>

                    <Grid item xs={12} style={{textAlign: 'center'}}>
                        <Button
                            variant="contained"
                            size="large"
                            style={{color: 'white', backgroundColor: '#262626', marginBottom: 20, textTransform: 'none', fontSize: 20}}
                            onClick={() => {
                                window.location.href = "intent://payment#Intent;action=ch.twint.action.TWINT_PAYMENT;scheme=twint;S.code=" + token + ";S.startingOrigin=EXTERNAL_WEB_BROWSER;S.browser_fallback_url=;end";
                            }}
                        >
                            {translate('custom.switch_to_the_app_now')}
                        </Button>
                    </Grid>

                    {twintDirectTokenAndroidIosCommonRenderer()}

                </Grid>

            </>
        )
    }

    function twintDirectTokenIosRenderer() {
        return (
            <>            
                <Grid container spacing={2} style={{backgroundColor: '#f5f5f5', flex: 1, justifyContent: 'space-around', paddingTop: 50}}>


                    <Grid item xs={4} style={{textAlign: 'center'}}>
                        <Button
                            onClick={() => {
                                setBankSelected('twint-issuer2://');
                            }}
                        >
                            <img src={bankUBS} width="70%" height="auto" />
                        </Button>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'center'}}>
                        <Button
                            onClick={() => {
                                setBankSelected('twint-issuer6://');
                            }}
                        >
                            <img src={bankRaiffeisen} width="70%" height="auto" />
                        </Button>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'center'}}>
                        <Button
                            onClick={() => {
                                setBankSelected('twint-issuer7://');
                            }}
                        >
                            <img src={bankPF} width="70%" height="auto" />
                        </Button>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'center'}}>
                        <Button
                            onClick={() => {
                                setBankSelected('twint-issuer3://');
                            }}
                        >
                            <img src={bankZKB} width="70%" height="auto" />
                        </Button>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'center'}}>
                        <Button
                            onClick={() => {
                                setBankSelected('twint-issuer4://');
                            }}
                        >
                            <img src={bankCS} width="70%" height="auto" />
                        </Button>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'center'}}>
                        <Button
                            onClick={() => {
                                setBankSelected('twint-issuer5://');
                            }}
                        >
                            <img src={bankBCV} width="70%" height="auto" />
                        </Button>
                    </Grid>


                    {/* Material UI dropdown */}
                    <Grid item xs={12} style={{textAlign: 'center'}}>
                        <Select
                            fullWidth
                            variant="outlined"
                            placeholder={translate('custom.select_bank')}
                            labelId="bank-select-label"
                            id="bank-select"
                            value={bankSelected}
                            onChange={(event) => {
                                setBankSelected(event.target.value);
                            }}
                            style={{width: '100%'}}
                            MenuProps={{
                                sx: {
                                    zIndex: 2000,
                                },
                                PaperProps: {
                                    sx: {
                                        zIndex: 2000,
                                    },
                                },
                            }}
                        >
                            <MenuItem value="twint-issuer1://">TWINT - autre banque &amp; prepaid</MenuItem>
                            <MenuItem value="twint-issuer25://">AEK TWINT</MenuItem>
                            <MenuItem value="twint-issuer30://">AKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer12://">AppKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer16://">BCF TWINT</MenuItem>
                            <MenuItem value="twint-issuer10://">BCGE TWINT</MenuItem>
                            <MenuItem value="twint-issuer17://">BCJ TWINT</MenuItem>
                            <MenuItem value="twint-issuer18://">BCN TWINT</MenuItem>
                            <MenuItem value="twint-issuer5://">BCV TWINT</MenuItem>
                            <MenuItem value="twint-issuer13://">BCVs TWINT</MenuItem>
                            <MenuItem value="twint-issuer23://">BEKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer26://">BLKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer33://">Baloise TWINT</MenuItem>
                            <MenuItem value="twint-issuer4://">Credit Suisse TWINT</MenuItem>
                            <MenuItem value="twint-issuer15://">GKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer22://">GLKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer32://">LUKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer21://">Migros Bank TWINT</MenuItem>
                            <MenuItem value="twint-issuer29://">NKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer8://">OKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer7://">PostFinance TWINT</MenuItem>
                            <MenuItem value="twint-issuer28://">Radicant TWINT</MenuItem>
                            <MenuItem value="twint-issuer6://">Raiffeisen TWINT</MenuItem>
                            <MenuItem value="twint-issuer14://">SGKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer24://">SHKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer31://">SZKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer27://">Swissquote TWINT</MenuItem>
                            <MenuItem value="twint-issuer19://">TKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer2://">UBS TWINT</MenuItem>
                            <MenuItem value="twint-issuer34://">UKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer20://">Valiant TWINT</MenuItem>
                            <MenuItem value="twint-issuer3://">ZKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer9://">ZugerKB TWINT</MenuItem>
                            <MenuItem value="twint-issuer35://">yuh TWINT</MenuItem>
                        </Select>
                    </Grid>


                    <Grid item xs={12} style={{textAlign: 'center'}}>
                        <Button
                            disabled={!bankSelected}
                            variant="contained"
                            size="large"
                            style={bankSelected ? {color: 'white', backgroundColor: '#262626', marginBottom: 20, textTransform: 'none', fontSize: 20} : {color: '#ccc', backgroundColor: '#999', marginBottom: 20, textTransform: 'none', fontSize: 20}}
                            onClick={() => {
                                window.location.href = bankSelected + 'applinks/?al_applink_data={"app_action_type": "TWINT_PAYMENT","extras": {"code": "' + token + '"},"referer_app_link": {"target_url": "", "url": "", "app_name": "EXTERNAL_WEB_BROWSER"}, "version": "6.0" }';
                            }}
                        >
                            {translate('custom.switch_to_the_app_now')}
                        </Button>
                    </Grid>


                    {twintDirectTokenAndroidIosCommonRenderer()}

                </Grid>

            </>
        )
    }

    if(platform == 'web') return twintDirectTokenWebRenderer();
    else if(platform == 'android') return twintDirectTokenAndroidRenderer();
    else if(platform == 'ios') return twintDirectTokenIosRenderer();
    return null;
}